// AI-förslag på segment och organisationstyp för befintliga kunder (vyn
// "Kategorisera kunder"). Samma mönster som signaturtolkningen: anropet går
// via gatewayen (callClaudeJSON → Cloud Function callClaude) med ett
// JSON-schema där svaren är låsta till listorna eller "okänt". Svaret
// kontrolleras ändå mot listorna (tolkaForslag). Inget sparas här.
import { callClaudeJSON } from '../../utils/claudeProxy';
import { kategoriAnrop, tolkaForslag } from './kundKategoriPrompt';

export { OKANT, MAX_PER_ANROP, tolkaForslag } from './kundKategoriPrompt';

/**
 * Förslag för upp till MAX_PER_ANROP kunder.
 * → { [id]: { segment, organisationstyp, motivering } } där segment/typ är ett
 *   värde ur listan eller OKANT.
 */
export async function foreslaKategorier(kunder) {
  if (!kunder.length) return {};
  const raw = await callClaudeJSON(kategoriAnrop(kunder));
  return tolkaForslag(raw, kunder.map(k => k.id));
}
